import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import { Box } from '@origin-digital/layout';
import keycode from 'keycode';
import * as React from 'react';
import { handlerFactory } from './handlerFactory.helper';
import { ripplePropTypes } from './Ripple.types';
import { detectFocusVisible, listenForFocusKeys } from '../../helpers/focusVisible.helper';
import { ownerWindow } from '../../helpers/ownerWindow.helper';
/**
 * React version 17 will deprecate several of the class component API
 * lifecycles, react-lifecycles-compat polyfill offers a way to use the new
 * lifecycles with older versions of React as well (0.14.9+) so no breaking
 * release is required. This enables our library to support both older and
 * newer versions of React simultaneously. 🎉
 */

import { TouchRipple } from './TouchRipple';
export var rippleInitialState = {
  focusVisible: false
};
/**
 * Ripple add ripple and focus magic to your rendered prop component
 */

var Ripple =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Ripple, _React$Component);

  function Ripple() {
    var _this;

    _classCallCheck(this, Ripple);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ripple).apply(this, arguments));
    _this.state = rippleInitialState;
    _this.ripple = null;
    _this.keyDown = false; // Used to help track keyboard activation keyDown

    _this.componentRef = null;
    _this.focusVisibleTimeout = null;
    _this.focusVisibleCheckTime = 50;
    _this.focusVisibleMaxCheckTimes = 5;
    _this.handleMouseDown = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.handleMouseUp = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'MouseUp', 'stop');
    _this.handleMouseLeave = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    });
    _this.handleTouchStart = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'TouchStart', 'start');
    _this.handleTouchEnd = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'TouchEnd', 'stop');
    _this.handleTouchMove = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'TouchMove', 'stop');
    _this.handleBlur = handlerFactory(_assertThisInitialized(_assertThisInitialized(_this)), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });

    _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    };

    _this.onRippleRef = function (node) {
      _this.ripple = node;
    };

    _this.setComponentRef = function (node) {
      _this.componentRef = node;
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          focus = _this$props.focus,
          onKeyDown = _this$props.onKeyDown;
      var key = keycode(event); // Check if key is already down to avoid repeats being counted as multiple activations

      if (focus && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // TODO: add Keyboard accessibility for non interactive elements

      /*     if (
        event.target === event.currentTarget &&
        component &&
        component !== 'button' &&
        (key === 'space' || key === 'enter')
      ) {
        event.preventDefault();
        if (onClick) {
          onClick(event);
        }
      } */

    };

    _this.handleKeyUp = function (event) {
      if (_this.props.focus && keycode(event) === 'space' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    };

    _this.handleFocus = function (event) {
      // Fix for https://github.com/facebook/react/issues/7769
      if (!_this.componentRef) {
        _this.componentRef = event.currentTarget;
      }

      event.persist();
      detectFocusVisible(_assertThisInitialized(_assertThisInitialized(_this)), _this.componentRef, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    return _this;
  }
  /**
   * getDerivedStateFromProps is invoked after a component is instantiated as
   * well as when it receives new props. It should return an object to update
   * state, or null to indicate that the new props do not require any state
   * updates.
   * @param nextProps
   * @param prevState
   */


  _createClass(Ripple, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      listenForFocusKeys(ownerWindow(this.componentRef));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.componentRef.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (this.props.focus && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentRef = null;
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          render = _this$props2.render,
          disabled = _this$props2.disabled,
          center = _this$props2.center,
          duration = _this$props2.duration,
          color = _this$props2.color,
          width = _this$props2.width,
          height = _this$props2.height;
      var renderProps = {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        showFocus: this.state.focusVisible
      };
      return React.createElement(Box, {
        height: height,
        width: width,
        display: "inlineFlex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      }, render && render(renderProps), !disabled ? React.createElement(TouchRipple, {
        ref: this.onRippleRef,
        center: center,
        duration: duration,
        color: color
      }) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);

  return Ripple;
}(React.Component);

Ripple.propTypes = ripplePropTypes;
Ripple.defaultProps = {
  center: false,
  focus: false,
  disabled: false,
  duration: 500,
  color: 'white',
  width: 'auto',
  height: 'auto'
};
export { Ripple };